import { useMutation } from 'react-query';
import { clientYardService } from '../../services';

export const useSendContractMutation = () => {
  return useMutation(clientYardService.sendContract);
};
